exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AsyncComponentDemo h4[data-v-077bc3eb]{color:#066}.AsyncComponentDemo .demoItem[data-v-077bc3eb]{padding:10px 0;font-size:18px}.AsyncComponentDemo .async-enter[data-v-077bc3eb],.AsyncComponentDemo .async-leave-to[data-v-077bc3eb]{opacity:0;margin-left:100px}.AsyncComponentDemo .async-enter-to[data-v-077bc3eb],.AsyncComponentDemo .async-leave[data-v-077bc3eb]{opacity:1;margin-left:0}.AsyncComponentDemo .async-enter-active[data-v-077bc3eb],.AsyncComponentDemo .async-leave-active[data-v-077bc3eb]{-webkit-transition:all 1s;transition:all 1s}", ""]);

// exports
